import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Content, Description } from './NoAppointment.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Text } from 'components/v2/Typography/Text';
import theme from 'kb-shared/theme';
import { pageUrl } from 'utilities/pageUrl';

export const NoAppointment = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Content>
        <Description>
          <Text size="lg" color={theme.colors.neutral.navy} fontStyle="semibold">
            You Have No Upcoming Appointments!
          </Text>
          <Text size="xs" color={theme.colors.neutral.navy}>
            When you book an appointment, it will appear here.
          </Text>
        </Description>

        <Button
          category="primary"
          label="Schedule Appointment"
          onClick={() => navigate(pageUrl.booking.bookingQuiz())}
          size="md"
        />
      </Content>
    </div>
  );
};
